import React, { useMemo, useState } from 'react'
import { useAtom } from 'jotai'
import { googleCredentialAtom } from 'store/atoms'
import errorImg from 'assets/error.svg'

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  src?: string
}

function Image({ src, ...rest }: Props) {
  const [googleCredential] = useAtom(googleCredentialAtom)

  // Proxy to plusbox api if needed to prevent CORS when downloading images
  const finalSrc = useMemo(() => {
    if (src?.startsWith('https://assets.betalabs.net/')) {
      const url = new URL(`${process.env.REACT_APP_PLUSBOX_API}/functions/images/${encodeURIComponent(src)}`)
      return url.toString()
    }
    return src
  }, [src, googleCredential])

  const [errorProps, setErrorProps] = useState({})

  return (
    // eslint-disable-next-line react/forbid-elements
    <img
      src={finalSrc}
      {...rest}
      {...errorProps}
      onError={e => {
        const img = e.target as any
        setErrorProps({
          src: errorImg,
          onLoad: async () => {
            // Convert img to svg to be able to apply style
            const s = document.createElement('div')
            s.innerHTML = await (await fetch(img.src)).text()
            const firstChild = s.firstChild as any
            if (firstChild) {
              firstChild.classList = `${img.classList} text-error`
              firstChild.style = 'min-width: 18px; min-height: 18px; object-fit: contain !important;'
              img.replaceWith(firstChild)
            }
          }
        })
      }}
    />
  )
}

export default Image
